export default "__VITE_ASSET__d007212e__"